import { combineReducers } from "@reduxjs/toolkit";
import basket from "./basketSlice";

const reducer = combineReducers({
  basket,
});

export default reducer;
